import { trpc } from '@client/utils/trpc';
import { Alert, Card, CardContent, CardProps, Skeleton, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts';

export type BestBlockChartCardProps = CardProps & {
  chain: string | null;
  showOffline?: boolean;
};

export const BestBlockChartCard = ({ chain, showOffline, ...rest }: BestBlockChartCardProps) => {
  const { data, status, error } = trpc.chart.bestBlock.useQuery({
    chain,
    showOffline,
  });

  return (
    <Card {...rest}>
      <CardContent>
        <Typography variant={'h5'}>{'Best Blocks'}</Typography>

        {status === 'success' ? (
          <PieChart
            height={256}
            hideLegend
            series={[
              {
                data: data.map((item) => ({
                  label: `#${item.height.toLocaleString()} (${item.hash})`,
                  value: item.count,
                })),
              },
            ]}
          />
        ) : status === 'error' ? (
          <Alert severity={'error'}>{error.message}</Alert>
        ) : (
          <Skeleton variant={'rounded'} height={256} />
        )}
      </CardContent>
    </Card>
  );
};
